<p-toast></p-toast>
<div class="app-farmers-challan">
    <p-card styleClass="p-card-shadow">
        <div class="card">
            <div class="p-fluid p-formgrid grid">
                <div class="field col-12 md:col-6">
                    <h4 class="mt-3 ">{{'MI_SURVEY_SUBSIDY_DISBURSEMENT' | translate}}</h4>
                </div>
    
    
                <div class="field col-12 md:col-6 grid">
                    <label class="mx-4" htmlFor="LotNo"><b>{{'SELECT_LOT_NUMBER' | translate}}</b></label>
                    <p-dropdown [options]="lotNumbersforDropDown" [(ngModel)]="selectedLotNumber" optionLabel="LotNo"
                        (onChange)="onSelectLotNumber()" placeholder="Select a lot number"
                        [style]="{'width':'20vw'}"></p-dropdown>
                </div>
            </div>
        </div>

        <div class="card mt-5" *ngIf="appFarmerChallanModel.length > 0">
            <p-table #appFarmerChallanTable [value]="appFarmerChallanModel" [(selection)]="selectedApplications"
                dataKey="AppId" (onRowSelect)="onRowSelect($event)" (onRowUnselect)="onRowUnselect($event)" [rows]="10"
                [paginator]="true"
                [globalFilterFields]="[
                'AppId',
                'Total_Billed_Amount',
                'Total_Cost_Verification',
                'District', 
                'Block', 
                'Village', 
                'FarmerShare', 
                'lotCreateTime', 
                'Crop_Name', 
                'FarmerName', 
                'PlantSpacing', 
                'RowSpacing',
                'gpsCoordinate',
                'MIArea',
                'LotRemarks',
                'BOQAmount',
                'BOQFarmerShare',
                'PaymentType',
                'AmountDeposited',
                'Admin_FarmerShare',
                'Admin_SubsidyToFarmer',
                'Admin_SubsidyToVendor',
                'Admin_FarmerRefund',
                'Admin_ApprovalDate',
                'CenterShare_Amount',
                'StateShare_Amount',
                ]"
                responsiveLayout="scroll" [rowHover]="true"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                [showCurrentPageReport]="true">
                <ng-template pTemplate="caption">
                    <div class="flex align-items-center justify-content-between">
                        <h5 class="m-0">{{'FARMER_APPLICATION_FOR_MI_SURVEY' | translate}}</h5>
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text"
                                (input)="appFarmerChallanTable.filterGlobal($any($event.target).value, 'contains')"
                                placeholder="Search..." />
                        </span>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th style="width: 3rem">
                            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                        </th>
                        <th pSortableColumn="AppId">{{'APP_ID' | translate}}
                            <p-columnFilter type="text" field="AppId" display="menu"></p-columnFilter>
                            <p-sortIcon field="AppId"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Total_Billed_Amount">{{'TOTAL_BILLED_AMOUNT' | translate}}
                            <p-columnFilter type="text" field="Total_Billed_Amount" display="menu"></p-columnFilter>
                            <p-sortIcon field="Total_Billed_Amount"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Total_Cost_Verification">{{'TOTAL_COST_VERIFICATION' | translate}}
                            <p-columnFilter type="text" field="Total_Cost_Verification" display="menu"></p-columnFilter>
                            <p-sortIcon field="Total_Cost_Verification"></p-sortIcon>
                        </th>
                        <th pSortableColumn="District">{{'DISTRICT' | translate}}
                            <p-columnFilter type="text" field="District" display="menu"></p-columnFilter>
                            <p-sortIcon field="District"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Block">{{'BLOCK' | translate}}
                            <p-columnFilter type="text" field="Block" display="menu"></p-columnFilter>
                            <p-sortIcon field="Block"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Village">{{'VILLAGE' | translate}}
                            <p-columnFilter type="text" field="Village" display="menu"></p-columnFilter>
                            <p-sortIcon field="Village"></p-sortIcon>
                        </th>
                        <th pSortableColumn="FarmerShare">{{'FARMER_SHARE' | translate}}
                            <p-columnFilter type="text" field="FarmerShare" display="menu"></p-columnFilter>
                            <p-sortIcon field="FarmerShare"></p-sortIcon>
                        </th>
                        <th pSortableColumn="lotCreateTime">{{'LOT_CREATE_TIME' | translate}}
                            <p-columnFilter type="text" field="lotCreateTime" display="menu"></p-columnFilter>
                            <p-sortIcon field="lotCreateTime"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Crop_Name">{{'CROP_NAME' | translate}}
                            <p-columnFilter type="text" field="Crop_Name" display="menu"></p-columnFilter>
                            <p-sortIcon field="Crop_Name"></p-sortIcon>
                        </th>
                        <th pSortableColumn="FarmerName">{{'FARMER_NAME' | translate}}
                            <p-columnFilter type="text" field="FarmerName" display="menu"></p-columnFilter>
                            <p-sortIcon field="FarmerName"></p-sortIcon>
                        </th>
                        <th pSortableColumn="PlantSpacing">{{'PLANT_SPACING' | translate }}
                            <p-columnFilter type="text" field="PlantSpacing" display="menu"></p-columnFilter>
                            <p-sortIcon field="PlantSpacing"></p-sortIcon>
                        </th><th pSortableColumn="RowSpacing">{{'ROW_SPACING' | translate}}
                            <p-columnFilter type="text" field="RowSpacing" display="menu"></p-columnFilter>
                            <p-sortIcon field="RowSpacing"></p-sortIcon>
                        </th>
                        <th pSortableColumn="gpsCoordinate">{{'GPS_COORDINATE' | translate}}
                            <p-columnFilter type="text" field="gpsCoordinate" display="menu"></p-columnFilter>
                            <p-sortIcon field="gpsCoordinate"></p-sortIcon>
                        </th>
                        <th pSortableColumn="MIArea">{{'MIAREA' | translate}}
                            <p-columnFilter type="text" field="MIArea" display="menu"></p-columnFilter>
                            <p-sortIcon field="MIArea"></p-sortIcon>
                        </th>
                        <th pSortableColumn="LotRemarks">{{'LOT_REMARKS' | translate}}
                            <p-columnFilter type="text" field="LotRemarks" display="menu"></p-columnFilter>
                            <p-sortIcon field="LotRemarks"></p-sortIcon>
                        </th>
                        <th pSortableColumn="BOQAmount">{{'BOQ_AMOUNT' | translate}}
                            <p-columnFilter type="text" field="BOQAmount" display="menu"></p-columnFilter>
                            <p-sortIcon field="BOQAmount"></p-sortIcon>
                        </th>
                        <th pSortableColumn="BOQFarmerShare">{{'BOQ_FARMER_SHARE' | translate}}
                            <p-columnFilter type="text" field="BOQFarmerShare" display="menu"></p-columnFilter>
                            <p-sortIcon field="BOQFarmerShare"></p-sortIcon>
                        </th>
                        <th pSortableColumn="PaymentType">{{'PAYMENT_TYPE' | translate}}
                            <p-columnFilter type="text" field="PaymentType" display="menu"></p-columnFilter>
                            <p-sortIcon field="PaymentType"></p-sortIcon>
                        </th>
                        <th pSortableColumn="AmountDeposited">{{'AMOUNT_DEPOSITED' | translate}}
                            <p-columnFilter type="text" field="AmountDeposited" display="menu"></p-columnFilter>
                            <p-sortIcon field="AmountDeposited"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Admin_FarmerShare">{{'ADMIN_FARMERSHARE' | translate}}
                            <p-columnFilter type="text" field="Admin_FarmerShare" display="menu"></p-columnFilter>
                            <p-sortIcon field="Admin_FarmerShare"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Admin_SubsidyToFarmer">{{'ADMIN_SUBSIDYTOFARMER' | translate}}
                            <p-columnFilter type="text" field="Admin_SubsidyToFarmer" display="menu"></p-columnFilter>
                            <p-sortIcon field="Admin_SubsidyToFarmer"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Admin_SubsidyToVendor">{{'ADMIN_SUBSIDYTOVENDOR' | translate}}
                            <p-columnFilter type="text" field="Admin_SubsidyToVendor" display="menu"></p-columnFilter>
                            <p-sortIcon field="Admin_SubsidyToVendor"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Admin_FarmerRefund">{{'ADMIN_FARMERREFUND' | translate}}
                            <p-columnFilter type="text" field="Admin_FarmerRefund" display="menu"></p-columnFilter>
                            <p-sortIcon field="Admin_FarmerRefund"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Admin_ApprovalDate">{{'ADMIN_APPROVALDATE' | translate}}
                            <p-columnFilter type="text" field="Admin_ApprovalDate" display="menu"></p-columnFilter>
                            <p-sortIcon field="Admin_ApprovalDate"></p-sortIcon>
                        </th>
                        <th pSortableColumn="CenterShare_Amount">{{'CENTER_SHARE_AMOUNT' | translate}}
                            <p-columnFilter type="text" field="CenterShare_Amount" display="menu"></p-columnFilter>
                            <p-sortIcon field="CenterShare_Amount"></p-sortIcon>
                        </th>
                        <th pSortableColumn="StateShare_Amount">{{'STATE_SHARE_AMOUNT' | translate}}
                            <p-columnFilter type="text" field="StateShare_Amount" display="menu"></p-columnFilter>
                            <p-sortIcon field="StateShare_Amount"></p-sortIcon>
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-product>
                    <tr>
                        <td>
                            <p-tableCheckbox [value]="product"></p-tableCheckbox>
                        </td>
                        <td>{{product.AppId}}</td>
                        <td>{{product.Total_Billed_Amount}}</td>
                        <td>{{product.Total_Cost_Verification}}</td>
                        <td>{{product.District}}</td>
                        <td>{{product.Block}}</td>
                        <td>{{product.Village}}</td>
                        <td>{{product.FarmerShare}}</td>
                        <td>{{product.lotCreateTime | date:'medium'}}</td>
                        <td>{{product.Crop_Name}}</td>
                        <td>{{product.FarmerName}}</td>
                        <td>{{product.PlantSpacing}}</td>
                        <td>{{product.RowSpacing}}</td>
                        <td>{{product.gpsCoordinate}}</td>
                        <td>{{product.MIArea}}</td>
                        <td>{{product.LotRemarks}}</td>
                        <td>{{product.BOQAmount}}</td>
                        <td>{{product.BOQFarmerShare}}</td>
                        <td>{{product.PaymentType}}</td>
                        <td>{{product.AmountDeposited}}</td>
                        <td>{{product.Admin_FarmerShare}}</td>
                        <td>{{product.Admin_SubsidyToFarmer}}</td>
                        <td>{{product.Admin_SubsidyToVendor}}</td>
                        <td>{{product.Admin_FarmerRefund}}</td>
                        <td>{{product.Admin_ApprovalDate | date:'medium'}}</td>
                        <td>{{product.CenterShare_Amount}}</td>
                        <td>{{product.StateShare_Amount}}</td>
                    </tr>
                </ng-template>
                <!-- <ng-template pTemplate="summary">
                    <div class="justify-content-end">
                        <button pButton type="button" label="Generate Challan" class="p-button-primary"
                            (click)="printChallan()"></button>
                    </div>
                </ng-template> -->
            </p-table>
        </div>
        <div class="card" *ngIf="selectedApplications.length">
            <h5><b>{{'TOTAL_NO_OF_APPLICATIONS_SELECTED_FOR_MI_SUREVY' | translate}}: {{ selectedApplications.length }}</b></h5>
            <div class="p-fluid p-formgrid grid">
                <div class="field col-12 md:col-4">
                    <p>{{'TOTAL_FARMER_SHARE_AMOUNT' | translate}}: {{ totalFarmerShareAmount }}</p>
                </div>
            </div>
            <div class="flex justify-content-end">
                <button (click)="menu.toggle($event)" pButton pRipple p-button-info label="{{'DOWNLOAD_FILTERED_LOT_DATA' | translate}}" icon="pi pi-upload"></button>
                <p-menu #menu [popup]="true" [model]="appVerificationItems"></p-menu>
            </div>
            
            <!-- <div class="card">
                <p-toolbar>
                        <ng-template pTemplate="left">
    
                        </ng-template>
                        <ng-template pTemplate="right">
                            <textarea id="description" [(ngModel)]="remarks" placeholder="Remarks" pInputTextarea required
                                rows="3" cols="20" class="mr-3"></textarea>
                            <button pButton pRipple label="Submit" (click)="onSubmit()" class="p-button-help"></button>
                        </ng-template>
                </p-toolbar>
            </div> -->
        </div>
    </p-card>
</div>

<p-confirmDialog [style]="{width: '400px'}"></p-confirmDialog>
